import {FC} from 'react'
import { BiographyTab } from '../../biography/components/tabs/BiographyTab'
import { ProfessionalOverviewTab } from '../../biography/components/tabs/ProfessionalOverviewTab'
import { LifestyleTab } from '../../biography/components/tabs/LifestyleTab'
import { RecognitionTab } from '../../biography/components/tabs/RecognitionTab'
import { ExpertiseTab } from '../../biography/components/tabs/ExpertiseTab'

interface MemberTabsProps {
  activeTab: string
  onTabChange: (tabId: string) => void
}

// PR-I-85: Expertise vuelve a la ficha publica del member (revierte parte de PR-I-80).
// Producto priorizo abrir el modulo a members.
const tabs = [
  {id: 'biography', label: 'Biography'},
  {id: 'professional', label: 'Professional Overview'},
  {id: 'lifestyle', label: 'Lifestyle'},
  {id: 'recognition', label: 'Recognition'},
  {id: 'expertise', label: 'Expertise'},
]

export const MemberTabs: FC<MemberTabsProps> = ({activeTab, onTabChange}) => {
  return (
    <div className='member-detail__tabs-section'>
      <div className='nb-pm-tabs-list'>
        {tabs.map((tab, index) => (
          <div className='tap-flex-center' key={tab.id}>
            <div
              className={`nb-pm-tabs-item ${
                activeTab === tab.id ? 'nb-pm-tabs-item--active' : ''
              }`}
              onClick={() => onTabChange(tab.id)}
            >
              <div className='nb-pm-tabs-item-text'>{tab.label}</div>
            </div>
            {index < tabs.length - 1 && (
              <svg className='ml_3' width='1' height='20' viewBox='0 0 1 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M0.5 0V20' stroke='#B4B4B4' />
              </svg>
            )}
          </div>
        ))}
      </div>

      <div className='bio-tabs__content'>
        {activeTab === 'biography' && <BiographyTab />}
        {activeTab === 'professional' && <ProfessionalOverviewTab />}
        {activeTab === 'lifestyle' && <LifestyleTab />}
        {activeTab === 'recognition' && <RecognitionTab />}
        {activeTab === 'expertise' && <ExpertiseTab />}
      </div>
    </div>
  )
}